export default __webpack_public_path__ + "images/eba7b68ff58411be9b7bd20544a8e588-reporting_sp2_1@2x.png";